// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.searchable-select-container {
  position: relative;
  width: 100%;
}

.searchable-select-label {
  display: block;
  margin-bottom: 6px;
  font-weight: 500;
  color: #374151;
  font-size: 14px;
}

.searchable-select-label .required {
  color: #dc2626;
  margin-left: 2px;
}

.searchable-select {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: white;
  cursor: pointer;
  transition: all 0.2s;
  min-height: 42px;
}

.searchable-select:hover {
  border-color: #1e3a8a;
}

.searchable-select.open {
  border-color: #1e3a8a;
  box-shadow: 0 0 0 3px rgba(30, 58, 138, 0.1);
}

.searchable-select-value {
  flex: 1 1;
  overflow: hidden;
}

.selected-option {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.selected-label {
  font-weight: 500;
  color: #111827;
}

.selected-subtitle {
  font-size: 12px;
  color: #6b7280;
}

.placeholder {
  color: #9ca3af;
  font-size: 14px;
}

.searchable-select-arrow {
  color: #6b7280;
  font-size: 12px;
  margin-left: 8px;
  transition: transform 0.2s;
}

.searchable-select.open .searchable-select-arrow {
  transform: rotate(180deg);
}

.searchable-select-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  z-index: 1000;
  max-height: 320px;
  display: flex;
  flex-direction: column;
  animation: slideDown 0.15s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.searchable-select-search {
  padding: 8px;
  border-bottom: 1px solid #e5e7eb;
}

.searchable-select-search input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s;
}

.searchable-select-search input:focus {
  border-color: #1e3a8a;
  box-shadow: 0 0 0 3px rgba(30, 58, 138, 0.1);
}

.searchable-select-options {
  overflow-y: auto;
  max-height: 240px;
}

.searchable-select-option {
  padding: 10px 12px;
  cursor: pointer;
  transition: background-color 0.15s;
  border-bottom: 1px solid #f3f4f6;
}

.searchable-select-option:last-child {
  border-bottom: none;
}

.searchable-select-option.highlighted {
  background-color: #f3f4f6;
}

.searchable-select-option.selected {
  background-color: #dbeafe;
  font-weight: 500;
}

.searchable-select-option:hover {
  background-color: #e5e7eb;
}

.searchable-select-option.create-new {
  background-color: #f0fdf4;
  color: #166534;
  font-weight: 500;
  border-bottom: 2px solid #86efac;
}

.searchable-select-option.create-new:hover {
  background-color: #dcfce7;
}

.option-label {
  font-weight: 500;
  color: #111827;
  font-size: 14px;
}

.option-subtitle {
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
}

.searchable-select-empty {
  padding: 20px;
  text-align: center;
  color: #9ca3af;
  font-size: 14px;
}

/* Scrollbar styling */
.searchable-select-options::-webkit-scrollbar {
  width: 8px;
}

.searchable-select-options::-webkit-scrollbar-track {
  background: #f3f4f6;
}

.searchable-select-options::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 4px;
}

.searchable-select-options::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}

/* Responsive */
@media (max-width: 768px) {
  .searchable-select-dropdown {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90%;
    max-width: 400px;
    max-height: 70vh;
  }

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translate(-50%, -50%) scale(0.95);
    }
    to {
      opacity: 1;
      transform: translate(-50%, -50%) scale(1);
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/SearchableSelect.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iFAAiF;EACjF,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,UAAU;IACV,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE;MACE,UAAU;MACV,4CAA4C;IAC9C;IACA;MACE,UAAU;MACV,yCAAyC;IAC3C;EACF;AACF","sourcesContent":[".searchable-select-container {\r\n  position: relative;\r\n  width: 100%;\r\n}\r\n\r\n.searchable-select-label {\r\n  display: block;\r\n  margin-bottom: 6px;\r\n  font-weight: 500;\r\n  color: #374151;\r\n  font-size: 14px;\r\n}\r\n\r\n.searchable-select-label .required {\r\n  color: #dc2626;\r\n  margin-left: 2px;\r\n}\r\n\r\n.searchable-select {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 10px 12px;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 6px;\r\n  background: white;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  min-height: 42px;\r\n}\r\n\r\n.searchable-select:hover {\r\n  border-color: #1e3a8a;\r\n}\r\n\r\n.searchable-select.open {\r\n  border-color: #1e3a8a;\r\n  box-shadow: 0 0 0 3px rgba(30, 58, 138, 0.1);\r\n}\r\n\r\n.searchable-select-value {\r\n  flex: 1;\r\n  overflow: hidden;\r\n}\r\n\r\n.selected-option {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n}\r\n\r\n.selected-label {\r\n  font-weight: 500;\r\n  color: #111827;\r\n}\r\n\r\n.selected-subtitle {\r\n  font-size: 12px;\r\n  color: #6b7280;\r\n}\r\n\r\n.placeholder {\r\n  color: #9ca3af;\r\n  font-size: 14px;\r\n}\r\n\r\n.searchable-select-arrow {\r\n  color: #6b7280;\r\n  font-size: 12px;\r\n  margin-left: 8px;\r\n  transition: transform 0.2s;\r\n}\r\n\r\n.searchable-select.open .searchable-select-arrow {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.searchable-select-dropdown {\r\n  position: absolute;\r\n  top: calc(100% + 4px);\r\n  left: 0;\r\n  right: 0;\r\n  background: white;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 6px;\r\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\r\n  z-index: 1000;\r\n  max-height: 320px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  animation: slideDown 0.15s ease-out;\r\n}\r\n\r\n@keyframes slideDown {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-8px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.searchable-select-search {\r\n  padding: 8px;\r\n  border-bottom: 1px solid #e5e7eb;\r\n}\r\n\r\n.searchable-select-search input {\r\n  width: 100%;\r\n  padding: 8px 12px;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n  outline: none;\r\n  transition: border-color 0.2s;\r\n}\r\n\r\n.searchable-select-search input:focus {\r\n  border-color: #1e3a8a;\r\n  box-shadow: 0 0 0 3px rgba(30, 58, 138, 0.1);\r\n}\r\n\r\n.searchable-select-options {\r\n  overflow-y: auto;\r\n  max-height: 240px;\r\n}\r\n\r\n.searchable-select-option {\r\n  padding: 10px 12px;\r\n  cursor: pointer;\r\n  transition: background-color 0.15s;\r\n  border-bottom: 1px solid #f3f4f6;\r\n}\r\n\r\n.searchable-select-option:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.searchable-select-option.highlighted {\r\n  background-color: #f3f4f6;\r\n}\r\n\r\n.searchable-select-option.selected {\r\n  background-color: #dbeafe;\r\n  font-weight: 500;\r\n}\r\n\r\n.searchable-select-option:hover {\r\n  background-color: #e5e7eb;\r\n}\r\n\r\n.searchable-select-option.create-new {\r\n  background-color: #f0fdf4;\r\n  color: #166534;\r\n  font-weight: 500;\r\n  border-bottom: 2px solid #86efac;\r\n}\r\n\r\n.searchable-select-option.create-new:hover {\r\n  background-color: #dcfce7;\r\n}\r\n\r\n.option-label {\r\n  font-weight: 500;\r\n  color: #111827;\r\n  font-size: 14px;\r\n}\r\n\r\n.option-subtitle {\r\n  font-size: 12px;\r\n  color: #6b7280;\r\n  margin-top: 2px;\r\n}\r\n\r\n.searchable-select-empty {\r\n  padding: 20px;\r\n  text-align: center;\r\n  color: #9ca3af;\r\n  font-size: 14px;\r\n}\r\n\r\n/* Scrollbar styling */\r\n.searchable-select-options::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n\r\n.searchable-select-options::-webkit-scrollbar-track {\r\n  background: #f3f4f6;\r\n}\r\n\r\n.searchable-select-options::-webkit-scrollbar-thumb {\r\n  background: #d1d5db;\r\n  border-radius: 4px;\r\n}\r\n\r\n.searchable-select-options::-webkit-scrollbar-thumb:hover {\r\n  background: #9ca3af;\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 768px) {\r\n  .searchable-select-dropdown {\r\n    position: fixed;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    width: 90%;\r\n    max-width: 400px;\r\n    max-height: 70vh;\r\n  }\r\n\r\n  @keyframes slideDown {\r\n    from {\r\n      opacity: 0;\r\n      transform: translate(-50%, -50%) scale(0.95);\r\n    }\r\n    to {\r\n      opacity: 1;\r\n      transform: translate(-50%, -50%) scale(1);\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
